export var DIALOG_NAME = 'Dialog';
export var PORTAL_NAME = 'DialogPortal';
export var OVERLAY_NAME = 'DialogOverlay';
export var CONTENT_NAME = 'DialogContent';
export var CLOSE_NAME = 'DialogClose';
export var TRIGGER_NAME = 'DialogTrigger';
export var DESCRIPTION_NAME = 'DialogDescription';